// @ts-nocheck
// Greif UI Kit = line-invoices
import React from "react";

const InvoicesLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M15.394 10.243c.535 0 .97.422.97.942-.001.52-.435.94-.97.94H8.605c-.535 0-.968-.421-.968-.94 0-.52.433-.942.968-.942zM13.252 7.09c.535 0 .97.422.97.942s-.434.942-.97.942H8.605c-.535 0-.968-.422-.968-.942s.433-.94.968-.941z"
            />
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17.231 3.273c1.328 0 2.406 1.006 2.406 2.247v13.345c0 1.333-1.708 2.019-2.743 1.103l-1.38-1.222-2.275 1.66c-.575.42-1.38.43-1.968.023l-2.478-1.72-1.748 1.4c-1.054.844-2.682.144-2.682-1.153V5.52c0-1.241 1.077-2.246 2.405-2.247zM6.312 5.343v12.954l1.41-1.127.111-.082a1.72 1.72 0 0 1 1.798-.059l.117.075 2.485 1.724 2.3-1.679.122-.08a1.72 1.72 0 0 1 1.882.083l.112.092 1.037.916.002-12.816z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(InvoicesLine);
